// extracted by mini-css-extract-plugin
export default {"overlay":"Fz-z","bodyOpen":"Gz-z","content":"Hz-z","header":"Iz-z","close":"Jz-z","closeNoHeading":"Kz-z"};